var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.625 10.7899V1.58529C1.625 0.652996 2.60928 0.0718249 3.39365 0.540991L11.5405 5.41403C12.3424 5.89365 12.3134 7.09339 11.4893 7.53153L3.34243 11.8631C2.55928 12.2795 1.625 11.6957 1.625 10.7899Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIc);
export default __webpack_public_path__ + "static/media/play_ic.dcda42a4fa51d59f16d2f95fd1e6d15c.svg";
export { ForwardRef as ReactComponent };